export default __webpack_public_path__ + "static/FancyMediaContentTwelve-2932a2443ae9950a2368c5426a6c5647.webp";